import { Box } from "@mui/material";
import type { FC } from "react";
import { ContentPreview } from "../../modules/content-previews/content-preview";
import { UpdateImageryButton } from "../../modules/content-previews/update-imagery-button";
import type { MultiformatConfig } from "../../modules/multiformat/store/types";

export const PreviewsSkeletons: FC<{
  multiformatConfig: MultiformatConfig;
}> = ({ multiformatConfig }) => {
  return (
    <>
      {multiformatConfig.layouts.some((l) => l.images.some((i) => i.type)) && (
        <UpdateImageryButton disabled={true} onOpen={() => {}} onClose={() => {}} />
      )}
      <Box
        sx={[
          (theme) => ({
            display: "grid",
            gap: 2,
            [theme.breakpoints.down("xs")]: {
              gridTemplateColumns: "1fr",
            },
            [theme.breakpoints.up("sm")]: {
              gridTemplateColumns: "repeat(2, 1fr)",
            },
            [theme.breakpoints.up("lg")]: {
              gridTemplateColumns: "repeat(2, 1fr)",
            },
          }),
        ]}
      >
        {Array.from({ length: 4 }).map((_, i) => (
          <ContentPreview
            key={i}
            image={{ state: "loading" }}
            hidden={false}
            dimensions={multiformatConfig.design_huddle!.dimensions!}
          />
        ))}
      </Box>
    </>
  );
};
